import { ConfigState } from '../../../models';
import { CONFIG_MUTATIONS_KEYS } from '../config.const';
import { ConfigMutation } from '../config.interfaces';

export class SetDeviceMutation implements ConfigMutation {
  mutations = {
    [CONFIG_MUTATIONS_KEYS.setDevice]: (config: ConfigState, device: string) => {
      config.device = device;
    }
  };

}
